import { render, staticRenderFns } from "./ConfigAlertSlack.vue?vue&type=template&id=4905f42c&"
import script from "./ConfigAlertSlack.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertSlack.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAlertSlack.vue?vue&type=style&index=0&id=4905f42c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports